'use client'

import { useState } from 'react'
import { RadioButtons } from '@dustin-web/microsite-components/src/atoms'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { FilterBox } from '@dustin-web/product-components/src/filters'
import ExpandButton from '@dustin-web/microsite-components/src/expand-button'
import type { RadioButtonType } from '@dustin-web/microsite-components/src/atoms/radio-button/radio-button'

type Props = {
  onTagClick: (arg0: string) => void
  clearTag?: () => void
  tags: RadioButtonType[]
  selectedTag: string
  showAll?: boolean
}

const TagFilter = ({ onTagClick, clearTag, tags, selectedTag, showAll = false }: Props) => {
  const { translate } = useTranslations()
  const [showAllTags, setshowAllTags] = useState(false)

  const clearTagsButton = clearTag && (
    <button
      className="button-stripped p-sm u-mb-0"
      disabled={!selectedTag?.length}
      onClick={() => {
        clearTag()
      }}>
      {translate('ResetAllFilters')}
    </button>
  )

  const activeTagIndex = tags.findIndex(tag => tag.value === selectedTag)

  return (
    <FilterBox title={translate('Tags_Filter')} additionalTopContent={clearTagsButton}>
      <div className="u-px-16 u-pt-16 u-pb-8">
        <RadioButtons
          name="tags filter"
          value={selectedTag}
          options={showAll || showAllTags || activeTagIndex > 19 ? tags : tags.slice(0, 20)}
          onChange={value => onTagClick(value)}
        />
        {!showAll && tags.length > 20 && (
          <ExpandButton
            className="u-w-100"
            collapsedTitle={translate('ShowMore')}
            expandedTitle={translate('ShowLess')}
            expanded={showAllTags}
            ariaControls="expandable-tags"
            onClick={() => setshowAllTags(!showAllTags)}
          />
        )}
      </div>
    </FilterBox>
  )
}

export default TagFilter
